import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { RawTransactionDto } from '@/features/dashboard/rawBankTransactions/types/RawTransactionDto.ts';
import { QualifyAsExpenseRequestDto } from '@/features/dashboard/rawBankTransactions/types/BankTransactionRequests.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useQualifyAsExpense = () => {
  const queryClient = useQueryClient();

  return useMutation<
    RawTransactionDto,
    Error,
    { id: string; request: QualifyAsExpenseRequestDto }
  >({
    mutationFn: ({ id, request }) =>
      rawBankTransactionsApi.qualifyAsExpense(id, request),
    onSuccess: () => {
      toast.success('Z przelewu powstał wydatek');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się zakwalifikować transakcji', {
        description: error.message,
      });
    },
  });
};

export default useQualifyAsExpense;
